module.exports = __webpack_public_path__ + "img/camera-white.52d4a2a4.svg";